import axios from 'CanExConfig/axios'

export const fetchTopSkills = async id => {
  const response = await axios(`/api/candidate/v2/candidate_profiles/${id}/skills`, {
    method: 'GET',
  })

  return response.data.result
}

export const updateTopSkills = async (id, data) => {
  const response = await axios(`/api/candidate/v2/candidate_profiles/${id}/skills`, {
    method: 'PATCH',
    data: {
      skills: data,
    },
  })

  return response.data.result
}
